import React, { FC, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ControlledDatePicker, FormGrid } from '../../../shared';
import { IClosedDaysFilter } from '../../models';

interface Props {
    filter: IClosedDaysFilter;
    onChange: (filter: IClosedDaysFilter) => void;
}

export const ClosedDaysFilter: FC<Props> = ({ filter, onChange }) => {
    const { t } = useTranslation();
    const form = useForm<IClosedDaysFilter>({ mode: 'onChange', defaultValues: filter });

    const formValues = form.watch();

    useEffect(() => {
        if (JSON.stringify(formValues) !== JSON.stringify(filter)) {
            onChange(formValues);
        }
    }, [formValues, filter, onChange]);

    return (
        <FormProvider {...form}>
            <FormGrid containerProps={{ alignItems: 'center', spacing: 1 }}>
                <ControlledDatePicker name="startDate" label={t('from')} size="small" />
                <ControlledDatePicker name="endDate" label={t('untilAndIncluding')} size="small" />
            </FormGrid>
        </FormProvider>
    );
};
